
import HomeLogo from "@/views/home/components/HomeLogo.vue";

export default {
  name: "HomeTop",
  components: { HomeLogo },
};
